import React from 'react'
import { observer } from 'mobx-react'
import cx from 'classnames'
import links from 'misc/links'
import Avatar from 'components/Avatar'
import { FlexContainer, FlexItem } from 'components/Flex'
import Link from 'components/Link'
import ShadowBox from 'components/ShadowBox'
import FloatingBadge from 'components/FloatingBadge'
import Circle from 'components/Circle'
import placeholderAvatar from 'assets/img/avatar-placeholder.png'

import './styles.sass'

@observer
export default class ProjectItem extends React.Component {
  render () {
    const { project } = this.props
    const classes = 'unstyled is-block project-item animated is-faster fadeInUp is-staggered'
    return (
      <Link className={classes} to={links.projectDetails(project.id)}>
        <ShadowBox className="is-relative" pad level={1}>
          {project.unreadCount > 0 &&
            <FloatingBadge animated>{project.unreadCount}</FloatingBadge>
          }
          <FlexContainer>
            <FlexItem>
              <Avatar
                url={project.provider ? project.provider.avatar : placeholderAvatar}
                fallback={project.provider ? project.provider.avatarFallback : null}
                size={64}
              />
            </FlexItem>
            <FlexItem className="has-spacing-left--less" stretch>
              <h3 className="project-name">{project.name}</h3>
              {project.provider
                ? (
                  <p className="project-provider-description">
                    Assigned to <span className="provider-name">{project.provider.name}</span>
                  </p>
                )
                : (
                  <p className="project-provider-description">
                    Not assigned yet
                  </p>
                )
              }
            </FlexItem>
            <FlexItem>
              <ProjectStatus project={project} />
            </FlexItem>
          </FlexContainer>
        </ShadowBox>
      </Link>
    )
  }
}

const ProjectStatus = observer(function ProjectStatus ({ project }) {
  return (
    <div className={cx('project-status', `project-status--${project.status}`)}>
      <FlexContainer alignItems="flex-end" direction="column">
        <FlexItem>
          <FlexContainer>
            <FlexItem vcentered>
              <Circle filled size={12} className="status-indicator" />
            </FlexItem>
            <FlexItem>
              <p className="last-milestone">{project.statusMessage}</p>
            </FlexItem>
          </FlexContainer>
        </FlexItem>
        <FlexItem>
          <p className="last-updated">{project.relevantStatusDate.format('LL LT')}</p>
        </FlexItem>
      </FlexContainer>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/client/screens/Projects/ProjectItem/index.jsx